import React, { FC } from "react";
import { ReactComponent as Accordion } from "assets/svg/accordion.svg";
import { ReactComponent as Acts } from "assets/svg/acts.svg";
import { ReactComponent as AddFile } from "assets/svg/addfile.svg";
import { ReactComponent as Alert } from "assets/svg/alert.svg";
import { ReactComponent as AlertError } from "assets/svg/error-alert.svg";
import { ReactComponent as ApprovedReport } from "assets/svg/approvedereport.svg";
import { ReactComponent as AppStore } from "assets/svg/appStore.svg";
import { ReactComponent as ChevronLeft } from "assets/svg/arrow-left.svg";
import { ReactComponent as ChevronUp } from "assets/svg/arrow-top.svg";
import { ReactComponent as ChevronDown } from "assets/svg/arrowdown.svg";
import { ReactComponent as ChevronRight } from "assets/svg/chevronRight.svg";
import { ReactComponent as ArrowRight } from "assets/svg/arrow-right.svg";
import { ReactComponent as ArrowUp } from "assets/svg/upArrow.svg";
import { ReactComponent as AttachReport } from "assets/svg/attachreport.svg";
import { ReactComponent as Avatar } from "assets/svg/avatar.svg";
import { ReactComponent as Book } from "assets/svg/book.svg";
import { ReactComponent as Building } from "assets/svg/building.svg";
import { ReactComponent as BriefCase } from "assets/svg/cabinet.svg";
import { ReactComponent as UserFile } from "assets/svg/cabinetList.svg";
import { ReactComponent as CalendarCheck } from "assets/svg/calendar-check.svg";
import { ReactComponent as Calendar } from "assets/svg/calendar-dates.svg";
import { ReactComponent as Call } from "assets/svg/call.svg";
import { ReactComponent as CancelCircle } from "assets/svg/cancelreport.svg";
import { ReactComponent as Cancel } from "assets/svg/close.svg";
import { ReactComponent as Car } from "assets/svg/car.svg";
import { ReactComponent as Chat } from "assets/svg/chat.svg";
import { ReactComponent as Check } from "assets/svg/check.svg";
import { ReactComponent as CheckCircle } from "assets/svg/check-blue.svg";
import { ReactComponent as UnCheckCircle } from "assets/svg/unchecked.svg";
import { ReactComponent as CheckSquare } from "assets/svg/check-green-square.svg";
import { ReactComponent as Comment } from "assets/svg/comment.svg";
import { ReactComponent as CornerDown } from "assets/svg/corner-down.svg";
import { ReactComponent as CornerRight } from "assets/svg/corner-right.svg";
import { ReactComponent as Diamond } from "assets/svg/diamond.svg";
import { ReactComponent as DocumentStack } from "assets/svg/documentStak.svg";
import { ReactComponent as ThinChevronDown } from "assets/svg/down-chevron.svg";
import { ReactComponent as ThinChevronRight } from "assets/svg/rightArrow.svg";
import { ReactComponent as Download } from "assets/svg/download.svg";
import { ReactComponent as Edit } from "assets/svg/edit.svg";
import { ReactComponent as EditLine } from "assets/svg/edit-white.svg";
import { ReactComponent as File } from "assets/svg/emptyList.svg";
import { ReactComponent as Signature } from "assets/svg/erikey.svg";
import { ReactComponent as SignatureCircle } from "assets/svg/footerIconpen.svg";
import { ReactComponent as ExportReport } from "assets/svg/exportreport.svg";
import { ReactComponent as FaxMark } from "assets/svg/faks-mark.svg";
import { ReactComponent as Farming } from "assets/svg/farming.svg";
import { ReactComponent as Filter } from "assets/svg/filter-setting.svg";
import { ReactComponent as Location } from "assets/svg/footerIconBook.svg";
import { ReactComponent as FAQ } from "assets/svg/footerIconQuestion.svg";
import { ReactComponent as FullScreen } from "assets/svg/full-screen.svg";
import { ReactComponent as GooglePlay } from "assets/svg/googlePlay.svg";
import { ReactComponent as Hamburger } from "assets/svg/hamburger.svg";
import { ReactComponent as Help } from "assets/svg/help.svg";
import { ReactComponent as InWork } from "assets/svg/in-work.svg";
import { ReactComponent as Key } from "assets/svg/key.svg";
import { ReactComponent as Logo } from "assets/svg/logo.svg";
import { ReactComponent as Mail } from "assets/svg/mail.svg";
import { ReactComponent as MailCertificate } from "assets/svg/mail-certificate.svg";
import { ReactComponent as FileCheck } from "assets/svg/mail-check.svg";
import { ReactComponent as MailStamp } from "assets/svg/mail-stamp.svg";
import { ReactComponent as MapPaper } from "assets/svg/map-paper.svg";
import { ReactComponent as Note } from "assets/svg/note.svg";
import { ReactComponent as Pencil } from "assets/svg/pencil-create.svg";
import { ReactComponent as Person } from "assets/svg/person.svg";
import { ReactComponent as Phone } from "assets/svg/phone-mark.svg";
import { ReactComponent as Print } from "assets/svg/print.svg";
import { ReactComponent as RatingChart } from "assets/svg/rating-chart.svg";
import { ReactComponent as Refresh } from "assets/svg/refresh.svg";
import { ReactComponent as Save } from "assets/svg/save-icon.svg";
import { ReactComponent as Search } from "assets/svg/search.svg";
import { ReactComponent as SendFile } from "assets/svg/sendFile.svg";
import { ReactComponent as ServiceMenu } from "assets/svg/serviceMenu.svg";
import { ReactComponent as Settings } from "assets/svg/settings.svg";
import { ReactComponent as Star } from "assets/svg/star.svg";
import { ReactComponent as Table } from "assets/svg/table.svg";
import { ReactComponent as Trash } from "assets/svg/trashreport.svg";
import { ReactComponent as Eagle } from "assets/svg/eagle.svg";
import { ReactComponent as FileSend } from "assets/svg/fileSend.svg";
import { ReactComponent as StampFile } from "assets/svg/stampFile.svg";
import { ReactComponent as FileEdit } from "assets/svg/fileEdit.svg";
import { ReactComponent as CardMachine } from "assets/svg/card-machine.svg";
import { ReactComponent as Warning } from "assets/svg/warning.svg";
import { ReactComponent as CircleMinus } from "assets/svg/circleMinus.svg";
import { ReactComponent as Chart } from "assets/svg/chart.svg";
import { ReactComponent as Upload } from "assets/svg/upload.svg";
import { ReactComponent as Eye } from "assets/svg/eye.svg";
import { ReactComponent as ArrowLeft } from "assets/svg/arrow-left.svg";
import { ReactComponent as DownArrow } from "assets/svg/downArrow.svg";
import { ReactComponent as ArrowRightWrapper } from "assets/svg/arrowRightWrapper.svg";
import { ReactComponent as ArrowLeftWrapper } from "assets/svg/arrowLeftWrapper.svg";
import { ReactComponent as UserIcon } from "assets/svg/users.svg";
import { ReactComponent as YoutubeIcon } from "assets/svg/youtube.svg";
import { ReactComponent as FileDocIcon } from "assets/svg/file_doc.svg";
import { ReactComponent as LuckIcon } from "assets/svg/luck.svg";
import { ReactComponent as UnLuckIcon } from "assets/svg/unluck.svg";
import { ReactComponent as RemoveIcon } from "assets/svg/remove.svg";
import { ReactComponent as PDFIcon } from "assets/svg/pdf.svg";
import { ReactComponent as WarringIcon } from "assets/svg/warring.svg";
import { ReactComponent as JPGIcon } from "assets/svg/jpg.svg";
import { ReactComponent as CirclePlusIcon } from "assets/svg/circle-plus.svg";
import { ReactComponent as Bookmarks } from "assets/svg/bookmarks.svg";
import { ReactComponent as InfoSvg } from "assets/svg/info.svg";
// circle-plus

export type IconProps =
	| "info"
	| "eye"
	| "accordion"
	| "acts"
	| "addFile"
	| "alert"
	| "alertError"
	| "approvedReport"
	| "appStore"
	| "chevronLeft"
	| "chevronUp"
	| "chevronDown"
	| "chevronRight"
	| "attachReport"
	| "avatar"
	| "book"
	| "building"
	| "briefCase"
	| "userFile"
	| "calendarCheck"
	| "calendar"
	| "call"
	| "cancelCircle"
	| "cancel"
	| "car"
	| "chat"
	| "check"
	| "checkCircle"
	| "unCheckCircle"
	| "checkSquare"
	| "comment"
	| "cornerDown"
	| "cornerRight"
	| "diamond"
	| "documentStack"
	| "thinChevronDown"
	| "thinChevronRight"
	| "download"
	| "edit"
	| "editLine"
	| "file"
	| "signature"
	| "signatureCircle"
	| "exportReport"
	| "faxMark"
	| "farming"
	| "filter"
	| "location"
	| "faq"
	| "fullScreen"
	| "googlePlay"
	| "hamburger"
	| "help"
	| "inWork"
	| "key"
	| "logo"
	| "mail"
	| "mailCertificate"
	| "fileCheck"
	| "mailStamp"
	| "mapPaper"
	| "note"
	| "pencil"
	| "person"
	| "phone"
	| "print"
	| "ratingChart"
	| "refresh"
	| "save"
	| "search"
	| "sendFile"
	| "serviceMenu"
	| "settings"
	| "star"
	| "table"
	| "trash"
	| "eagle"
	| "fileSend"
	| "stampFile"
	| "fileEdit"
	| "arrowRight"
	| "arrowUp"
	| "warning"
	| "circleMinus"
	| "upload"
	| "chart"
	| "cardMachine"
	| "arrowLeft"
	| "arrowRightWrapper"
	| "arrowLeftWrapper"
	| "downArrow"
	| "youtube"
	| "fileDoc"
	| "luck"
	| "unluck"
	| "remove"
	| "pdf"
	| "jpg"
	| "warring"
	| "users"
	| "plus"
	| "bookmarks";

type Props = {
	icon: IconProps;
	size?: number;
	color?: string;
	className?: string;
};

export const Icon: FC<Props> = ({ className, icon, size, color }) => {
	const icons = {
		accordion: <Accordion style={{ width: size, height: size, fill: color }} className={className} />,
		acts: <Acts style={{ width: size, height: size, fill: color }} className={className} />,
		addFile: <AddFile style={{ width: size, height: size, fill: color }} className={className} />,
		alert: <Alert style={{ width: size, height: size, fill: color }} className={className} />,
		alertError: <AlertError style={{ width: size, height: size, fill: color }} className={className} />,
		approvedReport: <ApprovedReport style={{ width: size, height: size, fill: color }} className={className} />,
		appStore: <AppStore style={{ width: size, height: size, fill: color }} className={className} />,
		chevronLeft: <ChevronLeft style={{ width: size, height: size, fill: color }} className={className} />,
		chevronUp: <ChevronUp style={{ width: size, height: size, fill: color }} className={className} />,
		chevronDown: <ChevronDown style={{ width: size, height: size, fill: color }} className={className} />,
		chevronRight: <ChevronRight style={{ width: size, height: size, fill: color }} className={className} />,
		arrowRight: <ArrowRight style={{ width: size, height: size, fill: color }} className={className} />,
		arrowUp: <ArrowUp style={{ width: size, height: size, fill: color }} className={className} />,
		attachReport: <AttachReport style={{ width: size, height: size, fill: color }} className={className} />,
		avatar: <Avatar style={{ width: size, height: size, fill: color }} className={className} />,
		book: <Book style={{ width: size, height: size, fill: color }} className={className} />,
		building: <Building style={{ width: size, height: size, fill: color }} className={className} />,
		briefCase: <BriefCase style={{ width: size, height: size, fill: color }} className={className} />,
		arrowLeft: <ArrowLeft style={{ width: size, height: size, fill: color }} className={className} />,
		userFile: <UserFile style={{ width: size, height: size, fill: color }} className={className} />,
		calendarCheck: <CalendarCheck style={{ width: size, height: size, fill: color }} className={className} />,
		calendar: <Calendar style={{ width: size, height: size, fill: color }} className={className} />,
		call: <Call style={{ width: size, height: size, fill: color }} className={className} />,
		cancel: <Cancel style={{ width: size, height: size, fill: color }} className={className} />,
		cancelCircle: <CancelCircle style={{ width: size, height: size, fill: color }} className={className} />,
		car: <Car style={{ width: size, height: size, fill: color }} className={className} />,
		chat: <Chat style={{ width: size, height: size, fill: color }} className={className} />,
		check: <Check style={{ width: size, height: size, fill: color }} className={className} />,
		checkCircle: <CheckCircle style={{ width: size, height: size, fill: color }} className={className} />,
		unCheckCircle: <UnCheckCircle style={{ width: size, height: size, fill: color }} className={className} />,
		checkSquare: <CheckSquare style={{ width: size, height: size, fill: color }} className={className} />,
		comment: <Comment style={{ width: size, height: size, fill: color }} className={className} />,
		cornerDown: <CornerDown style={{ width: size, height: size, fill: color }} className={className} />,
		cornerRight: <CornerRight style={{ width: size, height: size, fill: color }} className={className} />,
		diamond: <Diamond style={{ width: size, height: size, fill: color }} className={className} />,
		documentStack: <DocumentStack style={{ width: size, height: size, fill: color }} className={className} />,
		thinChevronDown: <ThinChevronDown style={{ width: size, height: size, fill: color }} className={className} />,
		thinChevronRight: <ThinChevronRight style={{ width: size, height: size, fill: color }} className={className} />,
		download: <Download style={{ width: size, height: size, fill: color }} className={className} />,
		edit: <Edit style={{ width: size, height: size, fill: color }} className={className} />,
		editLine: <EditLine style={{ width: size, height: size, fill: color }} className={className} />,
		file: <File style={{ width: size, height: size, fill: color }} className={className} />,
		signature: <Signature style={{ width: size, height: size, fill: color }} className={className} />,
		signatureCircle: <SignatureCircle style={{ width: size, height: size, fill: color }} className={className} />,
		exportReport: <ExportReport style={{ width: size, height: size, fill: color }} className={className} />,
		faxMark: <FaxMark style={{ width: size, height: size, fill: color }} className={className} />,
		farming: <Farming style={{ width: size, height: size, fill: color }} className={className} />,
		filter: <Filter style={{ width: size, height: size, fill: color }} className={className} />,
		location: <Location style={{ width: size, height: size, fill: color }} className={className} />,
		faq: <FAQ style={{ width: size, height: size, fill: color }} className={className} />,
		fullScreen: <FullScreen style={{ width: size, height: size, fill: color }} className={className} />,
		googlePlay: <GooglePlay style={{ width: size, height: size, fill: color }} className={className} />,
		hamburger: <Hamburger style={{ width: size, height: size, fill: color }} className={className} />,
		help: <Help style={{ width: size, height: size, fill: color }} className={className} />,
		key: <Key style={{ width: size, height: size, fill: color }} className={className} />,
		inWork: <InWork style={{ width: size, height: size, fill: color }} className={className} />,
		logo: <Logo style={{ width: size, height: size, fill: color }} className={className} />,
		mail: <Mail style={{ width: size, height: size, fill: color }} className={className} />,
		mailCertificate: <MailCertificate style={{ width: size, height: size, fill: color }} className={className} />,
		fileCheck: <FileCheck style={{ width: size, height: size, fill: color }} className={className} />,
		mailStamp: <MailStamp style={{ width: size, height: size, fill: color }} className={className} />,
		mapPaper: <MapPaper style={{ width: size, height: size, fill: color }} className={className} />,
		note: <Note style={{ width: size, height: size, fill: color }} className={className} />,
		pencil: <Pencil style={{ width: size, height: size, fill: color }} className={className} />,
		person: <Person style={{ width: size, height: size, fill: color }} className={className} />,
		phone: <Phone style={{ width: size, height: size, fill: color }} className={className} />,
		print: <Print style={{ width: size, height: size, fill: color }} className={className} />,
		ratingChart: <RatingChart style={{ width: size, height: size, fill: color }} className={className} />,
		refresh: <Refresh style={{ width: size, height: size, fill: color }} className={className} />,
		save: <Save style={{ width: size, height: size, fill: color }} className={className} />,
		search: <Search style={{ width: size, height: size, fill: color }} className={className} />,
		sendFile: <SendFile style={{ width: size, height: size, fill: color }} className={className} />,
		serviceMenu: <ServiceMenu style={{ width: size, height: size, fill: color }} className={className} />,
		settings: <Settings style={{ width: size, height: size, fill: color }} className={className} />,
		star: <Star style={{ width: size, height: size, fill: color }} className={className} />,
		table: <Table style={{ width: size, height: size, fill: color }} className={className} />,
		trash: <Trash style={{ width: size, height: size, fill: color }} className={className} />,
		eagle: <Eagle style={{ width: size, height: size, fill: color }} className={className} />,
		fileSend: <FileSend style={{ width: size, height: size, fill: color }} className={className} />,
		stampFile: <StampFile style={{ width: size, height: size, fill: color }} className={className} />,
		fileEdit: <FileEdit style={{ width: size, height: size, fill: color }} className={className} />,
		cardMachine: <CardMachine style={{ width: size, height: size, fill: color }} className={className} />,
		warning: <Warning style={{ width: size, height: size, fill: color }} className={className} />,
		chart: <Chart style={{ width: size, height: size, fill: color }} className={className} />,
		upload: <Upload style={{ width: size, height: size, fill: color }} className={className} />,
		circleMinus: <CircleMinus style={{ width: size, height: size, fill: color }} className={className} />,
		eye: <Eye style={{ width: size, height: size, fill: color }} className={className} />,
		downArrow: <DownArrow style={{ width: size, height: size, fill: color }} className={className} />,
		arrowRightWrapper: <ArrowRightWrapper style={{ width: size, height: size, fill: color }} className={className} />,
		arrowLeftWrapper: <ArrowLeftWrapper style={{ width: size, height: size, fill: color }} className={className} />,
		users: <UserIcon style={{ width: size, height: size, fill: color }} className={className} />,
		youtube: <YoutubeIcon style={{ width: size, height: size, fill: color }} className={className} />,
		fileDoc: <FileDocIcon style={{ width: size, height: size, fill: color }} className={className} />,
		luck: <LuckIcon style={{ width: size, height: size, fill: color }} className={className} />,
		unluck: <UnLuckIcon style={{ width: size, height: size, fill: color }} className={className} />,
		remove: <RemoveIcon style={{ width: size, height: size, fill: color }} className={className} />,
		pdf: <PDFIcon style={{ width: size, height: size, fill: color }} className={className} />,
		warring: <WarringIcon style={{ width: size, height: size, fill: color }} className={className} />,
		jpg: <JPGIcon style={{ width: size, height: size, fill: color }} className={className} />,
		plus: <CirclePlusIcon style={{ width: size, height: size, fill: color }} className={className} />,
		bookmarks: <Bookmarks style={{ width: size, height: size, fill: color }} className={className} />,
		info: <InfoSvg style={{ width: size, height: size, fill: color }} className={className} />
	};
	return icons[icon];
};
